<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import form from "./components/form";
export default {
  components: {
    form: form,
  },
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style lang="css">
html,
body,
.v-application {
  font-family: "Noto Sans JP", "メイリオ", Meiryo, "Hiragino Kaku Gothic Pro",
    "ヒラギノ角ゴ Pro W3", "ＭＳ Ｐゴシック", Arial, Verdana, sans-serif !important;
}
</style>
